import { Controller } from "stimulus"
import LoadingOverlay from "../../src/loading_overlay"

export default class extends Controller {
  static values = {
    action: String,
    pubKey: String,
    clientSecret: String,
    redirectUrl: String
  }

  static targets = ["errorMessage", "fields", "submitButton"];

  connect() {
    this.loadingOverlay = new LoadingOverlay()
    this.loadingOverlay.show(this.element, 'Loading stripe...')
    this.stripe = Stripe(this.pubKeyValue);
    this.elements = this.stripe.elements({
      clientSecret: this.clientSecretValue,
      appearance: {}
    });
    this.paymentElement = this.elements.create('payment');
    this.paymentElement.on('ready', (event) => {
      this.loadingOverlay.dismiss()
    });
    this.paymentElement.on('change', (event) => {
      this.submitButtonTarget.disabled = !event.complete
    });
    this.paymentElement.mount(this.fieldsTarget);
  }

  async completePayment(e) {
    e.preventDefault();
    this.loadingOverlay.show(this.element, 'Processing...')

    if (this.actionValue == "setup") {
      const {error} = await this.stripe.confirmSetup({
        elements: this.elements,
        confirmParams: {
          return_url: this.redirectUrlValue
        }
      })

      if (error) {
        this.errorMessageTarget.style.display = 'block';
        this.errorMessageTarget.textContent = error.message;
      } else {
        this.errorMessageTarget.style.display = 'none';
      }

      this.loadingOverlay.dismiss()
    }
  }
}